import { Polygon, Polyline, SpatialReference, Geometry } from "@arcgis/core/geometry";
import * as projection from "@arcgis/core/geometry/projection";

/**
 * Converts a given geometry to the specified spatial reference.
 * If the geometry is already in the desired spatial reference, it returns the original geometry.
 * 
 * @param {Polygon | Polyline} geometry - The input geometry (Polygon or Polyline).
 * @param {102100 | 4326} targetWkid - The WKID of the desired output spatial reference (102100 or 4326).
 * @returns {Promise<Geometry | null>} - The converted geometry, or null if an error occurs.
 */
export async function convertGeometrySpatialRefs(geometry: Polygon | Polyline, targetWkid: 102100 | 4326): Promise<Geometry | null> {
    try {
        if (geometry.spatialReference.wkid === targetWkid) {
            return geometry;
        }

        const outSpatialReference = new SpatialReference({ wkid: targetWkid });
        const convertedGeometry = projection.project(geometry, outSpatialReference);

        return convertedGeometry as Geometry;
    } catch (error) {
        console.error("Oops! Something went wrong while transforming the geometry:", error);
        return null;
    }
}
